import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import { Heading } from "@/ui/Heading";
import clsx from "classnames";
import classes from "./styles.module.scss";
import Image from "@/ui/Image";

export const TextImageGridBlocks = ({ className, title, content, items, footer_content, buttonName, buttonUrl }) => {
  return (
    <div className={clsx(className, classes.deliver)}>
      <Container>
        <Heading>
          <h2>{title}</h2>
        </Heading>
        <div className="mb-5" dangerouslySetInnerHTML={{ __html: content }} />
        <div className="mx-2">
          <Row className="position-relative">
            {items?.map((item, index) =>
              index % 2 === 0 ? (
                <>
                  <Col xs={12} lg={6} className="bg-light py-4 ps-4 pe-3 py-md-5 ps-md-5 pe-md-4 text-overlay">
                    <div className="text-overlay__content ms-0 ms-md-4">
                      <h4 className="mb-4 mb-md-5">{item?.title}</h4>
                      <div className="pb-4" dangerouslySetInnerHTML={{ __html: item?.content }} />
                    </div>

                    <Image
                      className="text-overlay__background"
                      img={{
                        path: "page.service.deliver.section-1.bg",
                        src: "/assets/grid/bg.png",
                      }}
                      size="x650"
                      alt=""
                    />
                  </Col>
                  <Col xs={12} lg={6} className="image-column p-5">
                    <img src={item?.image?.url} alt={item?.image?.alt} />
                  </Col>
                </>
              ) : (
                <>
                  <Col xs={12} lg={6} className="image-column p-5">
                    <img src={item?.image?.url} alt={item?.image?.alt} />
                  </Col>
                  <Col xs={12} lg={6} className="bg-light py-4 ps-4 pe-3 py-md-5 ps-md-5 pe-md-4 text-overlay">
                    <div className="text-overlay__content ms-0 ms-md-4">
                      <h4 className="mb-4 mb-md-5">{item?.title}</h4>
                      <div className="pb-4" dangerouslySetInnerHTML={{ __html: item?.content }} />
                    </div>

                    <Image
                      className="text-overlay__background"
                      img={{
                        path: "page.service.deliver.section-1.bg",
                        src: "/assets/grid/bg.png",
                      }}
                      size="x650"
                      alt=""
                    />
                  </Col>
                </>
              )
            )}
          </Row>
          <Row>
            <Stack className="flex-lg-row align-items-center px-0 py-4" gap={0}>
              <div className="flex-grow-1" dangerouslySetInnerHTML={{ __html: footer_content }} />
              <div>
                {buttonUrl && (
                  <Button className="btn-outline-primary text-nowrap" href={buttonUrl} tabIndex={undefined}>
                    {buttonName}
                  </Button>
                )}
              </div>
            </Stack>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default TextImageGridBlocks;
